// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalConfirmUser_container__KasYd","title":"ModalConfirmUser_title__WIXyB","subtitle":"ModalConfirmUser_subtitle__B7UTL","icon":"ModalConfirmUser_icon__Z5pgH"};